import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { Response } from 'src/app/models/response';
import { FinanciamientoApiService } from 'src/app/services/financiamiento-reusable.service';
import { ParametroApiService } from 'src/app/services/parametro.service';

@Component({
  selector: 'app-mensaje-financiamiento',
  templateUrl: './mensaje-financiamiento.component.html',
  styleUrls: ['./mensaje-financiamiento.component.scss']
})
export class MensajeFinanciamientoComponent implements OnInit {
  flagMessage: number;
  flagBotonAceptar: boolean;
  data: any;
  titulo: string;
  subTitulo: string;
  habilitaBanner: string;

  constructor(private serviceParametro: ParametroApiService,
    private globals: Globals,
    private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.habilitaBanner = sessionStorage.getItem('registroCompleto');
    this.flagMessage = this.globals.tipo_form_solicitante;
    this.caseMessage(this.flagMessage);
  }

  aceptar() {
    this.router.navigate(['']);
  }

  async caseMessage(flagMessage) {
    let flagTitulo = 0;
    let flagSubTitulo = 0;
    const codigo = 7;
    switch (flagMessage) {
      case 1:
        this.titulo = '¡Bienvenido!';
        this.subTitulo = 'Puedes realizar tu Afiliación al Recibo Digital.';
        break;
      case 2:
        flagTitulo = 50;
        flagSubTitulo = 51;
        break;
      case 3:
        flagTitulo = 52;
        flagSubTitulo = 53;
        break;
      case 4:
        flagTitulo = 59;
        flagSubTitulo = 60;
        break;
      case 5:
          flagTitulo = 61;
          flagSubTitulo = 62;
          break;  
      default:
        flagTitulo = 0;
        flagSubTitulo = 0;
        break;
    }
    if (flagTitulo !== 0) {
      this.titulo = await this.obtenerMensaje(String(codigo), String(flagTitulo));
    }
    if (flagSubTitulo !== 0) {
      this.subTitulo = await this.obtenerMensaje(String(codigo), String(flagSubTitulo));
    }

    const mailPrincipal = this.globals.mailPrincipal;
    if (mailPrincipal !== '' && (flagMessage === 3 || flagMessage === 5) ) {
      this.subTitulo = this.subTitulo.replace('{correo}', mailPrincipal);
    }
  }

  async obtenerMensaje(codigo: string, subcodigo: string) {
    let descripcion = '';
    await this.serviceParametro.consultarParametro(codigo, subcodigo).toPromise().then(
      (response: Response) => {
        if (response.estado === 'OK') {
          if (response.resultado) {
            descripcion = response.resultado[0].vl_val_parametro
          }
        }
      },
      (error) => {
        console.log("Error: " + error);
      }
    );
    return descripcion;
  }

}
